import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { t } from 'i18next';
import CopyButton from '../../../generic-components/CopyButton';
import { ReactComponent as CopyIcon } from '../../../assets/icons/svg/shared/ic-shared-copy.svg';

const COPY_BUTTON_TIMEOUT = 2000;

interface IProps {
  title: string;
  text: string;
}
export const TextWithCopy = ({ title, text }: IProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const copyToClipboard = () => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        mixpanel.track('Act on Incoming Wire Screen', {
          Action: 'Copy Account Number',
        });
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, COPY_BUTTON_TIMEOUT);
      });
    }
  };
  const copy = t('DIRECT_DEPOSIT_PAGE_COPY');
  const copied = t('DIRECT_DEPOSIT_PAGE_COPIED');

  return (
    <div className='w-full'>
      <span id='accountNumberText' className='text-bw05 text-[16px] font-metricR'>
        {title}
      </span>
      <div className='flex justify-between items-baseline mt-2'>
        <span id='accountNumber' className='font-metricSemibold text-[24px] text-bw08'>
          {text ?? ''}
        </span>
        <CopyButton
          id={`${title}-copy-button`}
          className='w-[2.625rem] flex flex-col items-center text-xs font-metric text-action03'
          title={isCopied ? copied : isFocused ? copy : ''}
          childElement={
            <CopyIcon
              id={`${title}-copy-icon`}
              className={`w-[1rem] h-[1.188rem] ${isFocused || isCopied ? 'text-action03' : 'text-bw05'}`}
            />
          }
          handleOnClick={() => {
            copyToClipboard();
          }}
          handleOnMouseIn={() => {
            setIsFocused(true);
          }}
          handleOnMouseOut={() => {
            setIsFocused(false);
          }}
        />
      </div>
      <div className='border-b border-bw03 mb-4' />
    </div>
  );
};
